/** Mirrors worker `OrgPlan` for UI gating. */

export type PlanSlug = 'free' | 'starter' | 'growth' | 'enterprise'

const RANK: Record<PlanSlug, number> = {
  free: 0,
  starter: 1,
  growth: 2,
  enterprise: 3,
}

export function planNameToSlug(name: string): PlanSlug {
  const n = name.trim().toLowerCase()
  if (n === 'free') return 'free'
  if (n === 'starter') return 'starter'
  if (n === 'growth') return 'growth'
  if (n === 'enterprise') return 'enterprise'
  return 'free'
}

export function normalizePlanFromApi(plan: string | undefined | null): PlanSlug {
  return planNameToSlug(plan ?? 'free')
}

export function planRank(slug: PlanSlug): number {
  return RANK[slug] ?? 0
}
